import { TransactionParkingType } from "@/graphql"

export function createParkingUpdateQueue() {
	let previous: Promise<unknown> = Promise.resolve()
	return <T>(update: () => Promise<T>): Promise<T> => {
		const pending = previous.then(update, update)
		previous = pending
		return pending
	}
}

export function displayedParkingTypes(
	parkingTypes: readonly TransactionParkingType[] | null | undefined,
	hasIndoorParking: boolean | null | undefined,
	hasOutdoorParking: boolean | null | undefined
): TransactionParkingType[] {
	if (parkingTypes != null) return [...parkingTypes]
	const inferred: TransactionParkingType[] = []
	if (hasIndoorParking === true) inferred.push(TransactionParkingType.Indoor)
	if (hasOutdoorParking === true) inferred.push(TransactionParkingType.Outdoor)
	if (hasIndoorParking === false && hasOutdoorParking === false) inferred.push(TransactionParkingType.None)
	return inferred
}

export function normalizeParkingSelection(
	previous: readonly TransactionParkingType[] | null | undefined,
	selected: readonly TransactionParkingType[]
): TransactionParkingType[] | null {
	const added = selected.find(value => !previous?.includes(value))
	if (added === TransactionParkingType.None || added === TransactionParkingType.Unknown) return [added]
	const types = selected.filter(
		value => value === TransactionParkingType.Indoor || value === TransactionParkingType.Outdoor
	)
	if (types.length > 0) return [...new Set(types)]
	return selected.length > 0 ? [selected[0]] : null
}
